import * as Yup from 'yup';

export const setupPhoneSchema = Yup.object().shape({
    phone: Yup.string().phone().ensure().required(),
});
